<!-- 支付方式选择 -->
<template>
  <van-popup
    v-model="show"
    round
    position="bottom"
    z-index="201"
    class="payment_way_popup"
    :style="{ height: 'auto' }"
    @close="handleClose"
  >
    <div class="payment_way_wrap">
      <div class="payment_way_title van-hairline--bottom">{{title}}</div>
      <div class="payment_way_content">
        <div
          class="payment_way_item van-hairline--bottom"
          :class="item.is_checked ? '' : 'cannot_pick'"
          v-for="item of paymentList"
          :key="item.id"
          @click="handelPickPaymentWay(item)"
        >
          <i
            class="payment_way_icon"
            :class="item.is_checked ? item.icon : `${item.icon} cannot_pay` "
            :style="`color:${item.color}`"
          ></i>
          <div class="payment_name">{{ item.name }}</div>
          <van-icon
            name="arrow"
            class="payment_check"
          />
        </div>
      </div>
      <div class="payment_btn_wrap">
        <div class="payment_btn_item">
          <van-button
            class="payment_btn payment_cancle"
            round
            @click="handlePaymentBtn('cancle')"
          >取消</van-button>
        </div>
        <div class="payment_btn_item">
          <van-button
            class="payment_btn payment_submit"
            round
            :disabled="submiting"
            @click="handlePaymentBtn('submit')"
          >确认</van-button>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
const paymentArrMob = [
  {
    id: 'wxpay',
    name: '微信支付',
    label: 'wxpay_jsapi',
    icon: 'ri-wechat-pay-fill',
    color: '#19be6b',
    is_checked: false,
  },
  {
    id: 'alipay',
    name: '支付宝支付',
    label: 'alipay_wappay',
    icon: 'ri-alipay-fill',
    color: '#0291ff',
    is_checked: false,
  },
  {
    id: 'paypal',
    name: 'Paypal 支付',
    label: 'paypal_checkout',
    icon: 'ri-paypal-fill',
    color: '#0569cc',
    is_checked: false,
  },
  {
    id: 'offline',
    name: '银行卡转账',
    label: 'offline_card',
    // icon: 'ri-exchange-cny-line',
    icon: 'ri-exchange-cny-fill',
    color: '#ff9900',
    is_checked: false,
  },
]
const paymentArrPc = [
  // {
  //   id: 'wxpay',
  //   name: '微信支付',
  //   label: 'wxpay_jsapi',
  //   icon: 'ri-wechat-pay-fill',
  //   color: '#19be6b',
  //   is_checked: false,
  // },
  {
    id: 'alipay',
    name: '支付宝支付',
    label: 'alipay_wappay',
    icon: 'ri-alipay-fill',
    color: '#0291ff',
    is_checked: false,
  },
  // {
  //   id: 'unionpay',
  //   name: '银联支付（信用卡）',
  //   label: 'unionpay',
  //   icon: 'ri-bank-card-fill',
  //   color: '#dd2c34',
  //   is_checked: false,
  // },
  {
    id: 'paypal',
    name: 'Paypal 支付',
    label: 'paypal_checkout',
    icon: 'ri-paypal-fill',
    color: '#0569cc',
    is_checked: false,
  },
  {
    id: 'offline',
    name: '银行卡转账',
    label: 'offline_card',
    // icon: 'ri-exchange-cny-line',
    icon: 'ri-exchange-cny-fill',
    color: '#ff9900',
    is_checked: false,
  },
]
import { ObjectDeepClone } from '@a/js/utils'
export default {
  props: {
    title: {
      type: String,
      default: '标题'
    },
    show: {
      type: Boolean,
      default: false,
    },
    payment: {
      type: Array,
      default: () => ([])
    },
    submiting: {
      type: Boolean,
      default: false
    }
  },
  name: 'PaymentWay',
  data() {
    return {
      paymentArrMob,
      paymentArrPc,
      // paymentList: [],
      paymentWay: '',
      hasInit: false,
      borwserType: 'mobile',
      isWeiXin: false,
    };
  },

  components: {},

  computed: {
    paymentList() {
      let arr = []
      let paymentArr = []
      if (this.borwserType === 'mobile') {
        paymentArr = ObjectDeepClone(this.paymentArrMob)
      } else {
        paymentArr = ObjectDeepClone(this.paymentArrPc)
      }
      if (!this.isWeiXin) {
        paymentArr.push({
          id: 'offline',
          name: '微信转账',
          label: 'offline_wx',
          icon: 'ri-wechat-pay-fill',
          color: '#19be6b',
          is_checked: false,
        })
      }
      paymentArr.map(item => {
        if (this.payment.indexOf(item.id) != -1) {
          item.is_checked = true
        } else {
          item.is_checked = false
        }
        arr.push(item)
      })

      // if (this.borwserType === 'mobile') {
      //   this.paymentArrMob.map(item => {
      //     if (this.payment.indexOf(item.id) != -1) {
      //       item.is_checked = true
      //     } else {
      //       item.is_checked = false
      //     }
      //     arr.push(item)
      //   })

      // } else {
      //   this.paymentArrPc.map(item => {
      //     if (this.payment.indexOf(item.id) != -1) {
      //       item.is_checked = true
      //     } else {
      //       item.is_checked = false
      //     }
      //     arr.push(item)
      //   })
      // }

      return arr

    }
  },

  methods: {
    // 判断浏览器类型
    judgeBrowser() {
      if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
        return ("mobile")
      }
      else {
        return ("pc")
      }
    },
    // 判断是否微信浏览器
    judgeIsWeiXin() {
      var ua = window.navigator.userAgent.toLowerCase();
      console.log(ua);//mozilla/5.0 (iphone; cpu iphone os 9_1 like mac os x) applewebkit/601.1.46 (khtml, like gecko)version/9.0 mobile/13b143 safari/601.1
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true;
      } else {
        return false;
      }
    },
    // 关闭支付方式选择
    handleClose() {
      this.$emit('listenClosePickPaymentMethod')
    },
    // 选择支付方式
    handelPickPaymentWay(data) {
      // console.log(data)
      // this.paymentList.map((item) => {
      //   item.is_checked = false
      //   if (item.id === data.id) {
      //     item.is_checked = true
      //     this.paymentWay = item.label
      //   }
      // })
      if (data.is_checked) {
        this.$emit('listenPickedPaymentWay', data.label)
      }
    },
    // 操作支付选择结果
    handlePaymentBtn(type) {
      if (type === 'cancle') {
        this.$emit('listenClosePickPaymentMethod')
      } else {
        this.hasInit = false
        this.$emit('listenWannaSubmitOrder', this.paymentWay)
        this.$emit('listenClosePickPaymentMethod')

      }
    },
    // 判断是否返回门票选择页面
    checkIsNeedToHide() {
      let pageName = this.$route.name
      if (pageName === 'Ticket') {
        this.$emit('listenClosePickPaymentMethod')
      }
    }
  },

  mounted() {
    this.borwserType = this.judgeBrowser()
    this.isWeiXin = this.judgeIsWeiXin()
  },
}
</script>
<style lang='less' scoped>
.payment_way_popup {
  z-index: 202 !important;
}
.payment_way_wrap {
  // min-height: 360px;
  .payment_way_title {
    font-size: 16px;
    text-align: center;
    line-height: 20px;
    padding: 15px 40px;
    letter-spacing: 1px;
    font-weight: bold;
    display: none;
  }
  .payment_way_content {
    padding: 10px 30px;
    // min-height: 220px;
    .payment_way_item {
      display: flex;
      height: 50px;
      line-height: 50px;
      .payment_way_icon {
        margin-right: 8px;
        font-size: 24px;
        color: #19be6b;
      }
      .cannot_pay {
        color: #ccc !important;
      }
      .payment_name {
        font-size: 14px;
        letter-spacing: 1px;
        flex: 1;
      }
      .payment_check {
        font-size: 24px;
        line-height: 50px;
        color: var(--btnBgColor);
      }
    }
    .cannot_pick {
      color: #ccc;
    }
    // .payment_way_item.van-hairline--bottom:last-child {
    //   &::after {
    //     border-bottom-width: 0px;
    //   }
    // }
  }
  .payment_btn_wrap {
    padding: 15px 0;
    display: flex;
    box-shadow: 0px -1px 10px rgba(0, 0, 0, 0.1);
    display: none;
    .payment_btn_item {
      flex: 1;
      text-align: center;
      .payment_btn {
        height: 40px;
        line-height: 40px;
        box-sizing: border-box;
        width: 160px;
        letter-spacing: 1px;
      }
      .payment_cancle {
        color: #999;
        border-color: #999;
      }
      .payment_submit {
        background-color: var(--bgColor);
        border-color: var(--bgColor);
        color: var(--fontColor);
      }
    }
  }
}
</style>